import { render, staticRenderFns } from "./ManageBeaconModal.vue?vue&type=template&id=9b0b04ae&scoped=true&"
import script from "./ManageBeaconModal.vue?vue&type=script&lang=js&"
export * from "./ManageBeaconModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0b04ae",
  null
  
)

export default component.exports